import { render, staticRenderFns } from "./GlobalSHeader.vue?vue&type=template&id=464baa9c&scoped=true"
import script from "./GlobalSHeader.vue?vue&type=script&lang=js"
export * from "./GlobalSHeader.vue?vue&type=script&lang=js"
import style0 from "./GlobalSHeader.vue?vue&type=style&index=0&id=464baa9c&prod&lang=less&scoped=true"
import style1 from "./GlobalSHeader.vue?vue&type=style&index=1&id=464baa9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464baa9c",
  null
  
)

export default component.exports